import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { useTenant } from './TenantContext';
import { listTenantUsers } from '../services/TeamService';

const TeamContext = createContext(null);

export const useTeam = () => {
  const context = useContext(TeamContext);

  if (!context) {
    throw new Error('useTeam must be used within a TeamProvider');
  }

  return context;
};

export const TeamProvider = ({ children }) => {
  const { activeTenantId } = useTenant();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const reloadUsers = useCallback(async () => {
    if (!activeTenantId) {
      setUsers([]);
      setError(null);
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);

    const result = await listTenantUsers(activeTenantId);

    if (!result.success) {
      setUsers([]);
      setError(result.error);
      setLoading(false);
      return;
    }

    setUsers(result.data);
    setLoading(false);
  }, [activeTenantId]);

  useEffect(() => {
    reloadUsers();
  }, [reloadUsers]);

  const value = {
    users,
    loading,
    error,
    reloadUsers
  };

  return (
    <TeamContext.Provider value={value}>
      {children}
    </TeamContext.Provider>
  );
};